import { FC, useEffect, useState } from 'react';
import { PickUpDetails, Transfer } from 'ts/transfer/interfaces/TransferResultsResponse';
import { DirectionsRenderer, GoogleMap, InfoWindow, Marker } from '@react-google-maps/api';
import { Position } from 'ts/transfer/interfaces/Transfer';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { imgWaypointA, imgWaypointB } from 'constants/generic';

interface TransferResultGoogleMapProps {
  transfer: Transfer;
  center: Position;
  mapData: {
    pickup: Position;
    dropoff: Position;
  };
  getLocalName: (item: PickUpDetails) => string;
  onChangeDirection: (distance: string) => void;
}

const TransferResultGoogleMap: FC<TransferResultGoogleMapProps> = ({ mapData, ...props }) => {
  const [openedMarker, setOpenedMarker] = useState(-1);
  const [directions, setDirections] = useState<google.maps.DirectionsResult>();

  useEffect(() => {
    const DirectionsService = new google.maps.DirectionsService();

    DirectionsService.route(
      {
        origin: new google.maps.LatLng(mapData.pickup.lat, mapData.pickup.lng),
        destination: new google.maps.LatLng(mapData.dropoff.lat, mapData.dropoff.lng),
        travelMode: google.maps.TravelMode.DRIVING,
      },
      (driving, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          props.onChangeDirection(driving?.routes[0]?.legs[0]?.distance?.text || '');
          setDirections(driving as google.maps.DirectionsResult);
        }
      }
    );
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <GoogleMap
      mapContainerClassName="map"
      center={props.center}
      options={{
        zoom: 6,
        streetViewControl: false,
        mapTypeControl: false,
      }}
    >
      <Marker
        position={mapData.pickup}
        icon={{ url: imgWaypointA }}
        onClick={() => setOpenedMarker(2)}
      >
        {openedMarker === 2 && (
          <InfoWindow onCloseClick={() => setOpenedMarker(-1)}>
            <div>{props.getLocalName(props.transfer.pickUpDetails)}</div>
          </InfoWindow>
        )}
      </Marker>
      <Marker
        position={mapData.dropoff}
        icon={{ url: imgWaypointB }}
        onClick={() => setOpenedMarker(1)}
      >
        {openedMarker === 1 && (
          <InfoWindow onCloseClick={() => setOpenedMarker(-1)}>
            <div>{props.getLocalName(props.transfer.dropOffDetails)}</div>
          </InfoWindow>
        )}
      </Marker>
      <DirectionsRenderer
        directions={directions}
        options={{
          suppressMarkers: true,
        }}
      />
    </GoogleMap>
  );
};

export default withErrorBoundary(TransferResultGoogleMap, 'TransferResultGoogleMap');
